
import Vue from "vue";
import AppDraggableResizeCombo from "@/components/layout-editor/DraggableResizeCombo.vue";
import { TextBlock } from "@/utils/label-layout/text-block";
import { Model } from "@/utils/models/model";

export default Vue.extend({
	props: {
		block: {
			type: Object as ()=>TextBlock,
			required: true
		},
		model: {
			type: Object as ()=>Model
		}
	},
	components: {
		AppDraggableResizeCombo
	}
});
